'use strict';

function uriUtility() {
	var keyPattern = '{key}';

	function fromPattern(uriPattern, parameters) {
		var parameterName;
		var parameterValue;
		var key;
		var keyIndex;

		for (parameterName in parameters) {
			parameterValue = parameters[parameterName];
			key = keyPattern.replace('key', parameterName);
			keyIndex = uriPattern.indexOf(key);

			if (keyIndex !== -1)
				uriPattern = uriPattern.replace(key, encodeURIComponent(parameterValue));
			else if (typeof parameterValue !== 'undefined')
				uriPattern += (uriPattern.indexOf('?') !== -1 ? '&' : '?') + encodeURIComponent(parameterName) + (parameterValue === null ? '' : ('=' + encodeURIComponent(parameterValue)));
		}

		return uriPattern;
	}

	return {
		fromPattern: fromPattern,
		setKeyPattern: function (pattern) {
			if (typeof pattern !== 'string' || pattern.indexOf('key') === -1)
				throw 'Pattern must contain the replacement token "key". Eg, ":key".';

			keyPattern = pattern;
		}
	};
}

module.exports = uriUtility();